import React, { useState } from 'react';
import axios from 'axios';
import toastr from 'toastr';

const KuotaForm = ({ onLoadingChange }) => {
  const [msisdn, setMsisdn] = useState('');
  const [result, setResult] = useState('');

  const checkKuota = async () => {
    if (!msisdn) {
      toastr.error('Mohon masukkan nomor telepon');
      return;
    }

    // Mulai loading
    onLoadingChange(true);

    try {
      const response = await axios.get(
        `https://apigw.kmsp-store.com/sidompul/v4/cek_kuota?msisdn=${msisdn}&isJSON=true`,
        {
          headers: {
            'Authorization': 'Basic c2lkb21wdWxhcGk6YXBpZ3drbXNw',
            'X-API-Key': '60ef29aa-a648-4668-90ae-20951ef90c55',
            'X-App-Version': '4.0.0'
          }
        }
      );

      if (response.data.status === false) {
        toastr.error(response.data.message);
        setResult(`<br><font style="color: red;"><b>${response.data.data.keteranganError}</b></font>`);
      } else {
        toastr.success(response.data.message);
        setResult(`<br>${response.data.data.hasil}`);
      }
    } catch (error) {
      toastr.error('Terjadi kesalahan. Silakan coba lagi!');
      setResult('');
    } finally {
      // Selesai loading
      onLoadingChange(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      checkKuota();
    }
  };

  return (
    <div id="formnya">
      <div className="form-group">
        <label htmlFor="msisdn">
          <i className="fa fa-mobile" style={{ marginRight: '8px', color: '#4361ee' }}></i>
          MSISDN/Nomor XL/AXIS Kamu:
        </label>
        <input 
          type="number" 
          className="form-control" 
          id="msisdn" 
          placeholder="Contoh: 08123456789 atau 628123456789" 
          value={msisdn}
          onChange={(e) => setMsisdn(e.target.value)}
          onKeyPress={handleKeyPress}
          maxLength="16" 
          required
          style={{
            background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
            border: '2px solid #dee2e6',
            fontSize: '16px',
            padding: '15px 20px'
          }}
        />
        <small className="text-muted" style={{ display: 'block', marginTop: '5px', fontSize: '12px' }}>
          Masukkan nomor XL atau AXIS Anda (contoh: 08xxx atau 628xxx)
        </small>
      </div>
      <button 
        type="button" 
        id="submitCekKuota" 
        className="btn btn-primary"
        onClick={checkKuota}
        style={{
          background: 'linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%)',
          border: 'none',
          fontSize: '16px',
          fontWeight: '600',
          padding: '15px',
          marginTop: '15px',
          cursor: 'pointer',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.background = 'linear-gradient(135deg, #3f37c9 0%, #3a0ca3 100%)';
          e.target.style.transform = 'translateY(-3px)';
        }}
        onMouseLeave={(e) => {
          e.target.style.background = 'linear-gradient(135deg, #4361ee 0%, #3a0ca3 100%)';
          e.target.style.transform = 'translateY(0)';
        }}
      >
        <i className="fa fa-search" aria-hidden="true" style={{ marginRight: '10px' }}></i> 
        Cek Kuota Sekarang
      </button>
      
      {result && (
        <div 
          id="hasilnya" 
          style={{ 
            textAlign: 'justify',
            animation: 'fadeIn 0.5s ease-out',
            background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
            borderLeft: '5px solid #4361ee'
          }}
          dangerouslySetInnerHTML={{ __html: result }}
        />
      )}
    </div>
  );
};

export default KuotaForm;
